import { render, staticRenderFns } from "./EmplDayDelete.vue?vue&type=template&id=6208bade&scoped=true"
import script from "./EmplDayDelete.vue?vue&type=script&lang=js"
export * from "./EmplDayDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208bade",
  null
  
)

export default component.exports